const LANDER_GIFT_PARAM_KEY = 'rips_gift';
const LANDER_GIFT_STORAGE_KEY = 'crown-rips-lander-gift';

// Crown Rips lander gift (AT-239): /crown-rips?rips_gift=<key> promises a free pack on signup. The key is
// persisted at lander load (the auth wizard and payment-redirect handling can wipe query params) and
// rides the user/login signup payload; the backend grants only for brand-new accounts.
export class LanderGiftService {
  static captureFromUrl() {
    const key = new URLSearchParams(window.location.search).get(LANDER_GIFT_PARAM_KEY);
    if (!key) return;
    try {
      localStorage.setItem(LANDER_GIFT_STORAGE_KEY, key);
    } catch {
      // Blocked storage (private mode) — the URL-param fallback in getLanderGiftKey still covers signup.
    }
  }

  static getLanderGiftKey(): string | undefined {
    const fromUrl = new URLSearchParams(window.location.search).get(LANDER_GIFT_PARAM_KEY);
    if (fromUrl) return fromUrl;
    try {
      return localStorage.getItem(LANDER_GIFT_STORAGE_KEY) ?? undefined;
    } catch {
      return undefined;
    }
  }

  static clear() {
    try {
      localStorage.removeItem(LANDER_GIFT_STORAGE_KEY);
    } catch {
      // Nothing to clean when storage is blocked.
    }
  }
}
